<template>
  <div
    class="normal-case leading-5 whitespace-pre-line"
    :class="ellipsis ? 'line-clamp-3' : 'flex align-center flex-1 text-wrap'"
  >
    <StatusDotText :text="program.teaser || `Ce patient est ciblé par le programme ${program.name}`" />
  </div>
</template>

<script lang="ts" setup>
import {ProgramSnapshot} from "@/program/interfaces/Program";
import StatusDotText from "@/core/components/ui/badge/StatusDotText.vue";

withDefaults(defineProps<{
    /** The program to get the teaser from. */
    program: ProgramSnapshot

    /** Enable text ellipsis after 3 lines */
    ellipsis?: boolean
}>(), { ellipsis: false });
</script>
